import {
  LOCATION_START,
  LOCATION_SUCCESS,
  LOCATION_ERROR,
} from './LocationTypes';

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: [],
};

export default (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOCATION_START:
      return { ...state, loading: true, error: null };

    case LOCATION_SUCCESS:
      return { ...state, data: action.payload, loading: false };

    case LOCATION_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
